import React, { useState, useEffect } from "react";
import { getRejectReasonCountOverall, DownloadRejectReasonDataByDate } from "../maketingComponents/actioncreator";
import { firstDateOfMonth, formatDate, lastDateOfMonth, monthStartDate, reverseFormat, subtractOneDay, todayDate } from "../maketingComponents/utils/utils";
import ReactApexChart from "react-apexcharts";
import Skeleton from "react-loading-skeleton";
import Loader from '../../../presentationals/Loader/Loader.component'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../reducers/CommonFilters.reducer';
import moment from "moment";

const StatewiseData = ({ admin }) => {
    const dispatch = useDispatch();
    const { fromDate: ReducerFrom, toDate: ReducerTo } = useSelector(state => state.FilterReduce.commonFilters);
    const [loader, setLoader] = useState(false)
    const [nameOpportunity, setNameopportunity] = useState([])
    const [dataOpportunity, setDataopportunity] = useState([])

    const [payload, setPayload] = useState({
        fromDate: moment(ReducerFrom).format("DD-MM-YYYY"),
        toDate: moment(ReducerTo).format("DD-MM-YYYY"),
        minDate: moment(ReducerFrom).format("DD-MM-YYYY"),
    });
    const [rejectReasonData, setRejectReasonData] = useState([]);
    const [graphData, setGraphData] = useState([]);
    const [optionsData, setOptionsData] = useState('');
    const [today, setToday] = useState(todayDate())

    useEffect(() => {
        setPayload({
            fromDate: moment(ReducerFrom).format("DD-MM-YYYY"),
            toDate: moment(ReducerTo).format("DD-MM-YYYY"),
            minDate: moment(ReducerFrom).format("DD-MM-YYYY"),
        })
        getdataapi();
    }, [ReducerFrom, ReducerTo]);

    const getdataapi = () => {
        getRejectReasonCountOverall(
            payload,
            (callBack) => {

                setRejectReasonData(callBack);
                makegraphDataOpportunity(callBack)


            },
            (error) => {
                console.log(error);
            }
        );
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (e.target.type == "date") {
            dispatch({ type: FILTER_ACTION, payload: { [name]: e.target.value } });
        }
        const newPayload = {
            ...payload,
            [name]: formatDate(value),
        };
        if (name === "fromDate") {
            newPayload.toDate = payload.toDate;
        } else {
            newPayload.fromDate = payload.fromDate;
        }
        setPayload(newPayload);
    };

    const prepareChartData = (data) => {

        const categories = Object.values(data.xaxis.categories);
        const seriesData = Object.values(data.xaxis.categories);
        const options = {
            series: [{
                data: seriesData
            }],
            chart: {
                type: 'bar',
                height: 350
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: categories
            }
        };
        setOptionsData(options);
        console.log(options)
    };


    const makegraphDataOpportunity = (To) => {
        let name = [];
        let data = [];

        for (const item of To) {
            const { count, loanRejectReason, percentage } = item;
            if (loanRejectReason !== '' && loanRejectReason !== null) {

                name.push(loanRejectReason);
            }
            data.push(count);
        }

        setNameopportunity(name);
        setDataopportunity(data);

        console.log(Object.values(nameOpportunity))

    }
    var options = {
        series: [{
            data: Object.values(dataOpportunity),

        }],
        chart: {
            type: 'bar',
            height: 350
        },
        plotOptions: {
            bar: {

                horizontal: true,
                barHeight: '90%',
                barWidth: '90%',

            }

        },
        colors: ['#7978E9'],
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: nameOpportunity,
        },


    };


    const downloadReport = () => {
        setLoader(true)
        DownloadRejectReasonDataByDate(payload.fromDate, payload.toDate, callback => {
            setLoader(false)
        })
    }

    return (
        <>
            {loader ? <Loader /> : ""}
            <div>
                <div className="col-sm-12 col-xs-12 shadow" style={{ marginBottom: '20px', border: '1px solid rgba(0, 0, 0, 0.25)', borderRadius: '10px', minHeight: '600px' }}>
                    <div className="bg-white p-4 " style={{ padding: '15px' }}>
                        <h5 style={{ color: '#1d3557', fontWeight: '700' }}> <strong style={{ paddingTop: '10px' }}>Leads Particulars</strong></h5>
                        <div className="row">
                            <div className="col-sm-2 col-xs-12" style={{ marginTop: '4px' }}>
                                From
                                <input
                                    type="date"
                                    id="startDate"
                                    placeholder="DD/MM/YY"
                                    name="fromDate"
                                    value={reverseFormat(payload.fromDate)}
                                    onChange={handleChange}
                                    className=" form-control"
                                    style={{
                                        border: "1px solid gray",
                                        borderRadius: "6px",
                                        padding: "10px",
                                    }}
                                />
                            </div>

                            <div className="col-sm-2 col-xs-12">
                                <div className="filterHeaders" style={{ marginTop: "4px" }}>
                                    to
                                </div>

                                <input
                                    type="date"
                                    id="endDate"
                                    name="toDate"
                                    max={reverseFormat(today)}
                                    value={reverseFormat(payload.toDate)}
                                    onChange={handleChange}
                                    placeholder="DD/MM/YY"
                                    className=" form-control"
                                    style={{
                                        border: "1px solid gray",
                                        borderRadius: "6px",
                                        padding: "10px",
                                    }}
                                />
                            </div>
                            <div className="col-sm-2 col-xs-12">
                                <button
                                    className="btn reset-btn mt-4 "
                                    style={{
                                        // color: "#006c67",
                                        // borderColor: "#006c67",
                                        // backgroundColor: "white",
                                        marginTop: "23px",
                                        padding: "10px",
                                        borderRadius: "5px",
                                    }}
                                    onClick={getdataapi}
                                >
                                    Apply Filter
                                </button>
                            </div>
                            <div className="col-sm-2 col-xs-12">
                                <button
                                    className="btn reset-btn mt-4 "
                                    style={{
                                        // color: "#006c67",
                                        // borderColor: "#006c67",
                                        // backgroundColor: "white",
                                        marginTop: "23px",
                                        padding: "10px",
                                        borderRadius: "5px",
                                    }}
                                    onClick={() => downloadReport()}
                                >
                                    Download
                                </button>
                            </div>
                        </div>


                        <hr />
                        <div className="row">
                            <div className="col-sm-6 col-xs-12 other-table">
                                <div className='credit-table' style={{ fontSize: '12px', width: '90%', marginRight: 'auto' }} >
                                    <table>
                                        <thead style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                            <tr className="thead-class">
                                                <th style={{ width: '20%', }} className="">
                                                    <b>Reason</b>
                                                </th>
                                                <th style={{ width: '20%' }} className="">
                                                    <b>Counts</b>
                                                </th>
                                                <th style={{ width: '20%' }} className="">
                                                    <b>Percentage (%)</b>
                                                </th>
                                            </tr>
                                        </thead>
                                        {rejectReasonData.length > 0 ?
                                            <tbody style={{ height: '800px', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                                {rejectReasonData.map((data1, i) => {
                                                    if (data1.loanRejectReason) {
                                                        return (
                                                            <tr style={{ borderBottom: "none", fontWeight: '400' }} key={i}>
                                                                <td style={{ width: '20%' }} scope="col">
                                                                    {data1.loanRejectReason}
                                                                </td>
                                                                <td style={{ width: '20%' }} scope="col">
                                                                    {data1.count}
                                                                </td>
                                                                <td style={{ width: '20%' }} scope="col">
                                                                    {data1.percentage}
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                    return null;
                                                })}
                                                <tr className="thead-class" style={{ fontWeight: 'bold', background: '#B9D8F973' }}>
                                                    <td style={{ borderBottomLeftRadius: '10px' }}><b>Total</b></td>
                                                    <td>
                                                        <b>{rejectReasonData.reduce((total, data) => total + data.count, 0)}</b>
                                                    </td>
                                                    <td style={{ borderBottomRightRadius: '10px' }}></td>
                                                </tr>

                                            </tbody>
                                            :
                                            <tbody style={{ height: '800px', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>

                                                </tr>

                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>

                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                                <tr>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                    <td><Skeleton height={40} /></td>
                                                </tr>
                                            </tbody>
                                        }
                                    </table>
                                </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                                <div style={{ border: '1px solid rgba(0, 0, 0, 0.15)', padding: '10px', borderRadius: '10px', marginTop: '21px' }}>
                                    <h5><b>Rejection Stats</b></h5>
                                    <ReactApexChart options={options} series={options.series} type="bar" height={800} width={'100%'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StatewiseData;
